export const getFormattedSnils = (snils: string) => {
	if (!snils) return ''

    const match = snils.match(/^(\d{3})(\d{3})(\d{3})(\d{2})$/)
    
    if (match) return `${match[1]}-${match[2]}-${match[3]} ${match[4]}`
    
    return snils
}
